import { create } from 'zustand'

/**
 * Text prepared for a conversation's composer from another screen (e.g. the
 * birthday wish written from the Birthdays page). Memory only, and not a route
 * param: on the web, params end up in the URL.
 */
export type MessageDraft = { status: 'pending' } | { status: 'ready'; text: string }

interface MessageDraftState {
  drafts: Record<string, MessageDraft>
  /** The text is being written; the composer shows a hint meanwhile. */
  startDraft: (conversationId: string) => void
  fillDraft: (conversationId: string, text: string) => void
  /** Called by the composer once it has taken the text. */
  clearDraft: (conversationId: string) => void
}

export const useMessageDraftStore = create<MessageDraftState>()((set) => ({
  drafts: {},
  startDraft: (conversationId) =>
    set((s) => ({ drafts: { ...s.drafts, [conversationId]: { status: 'pending' } } })),
  fillDraft: (conversationId, text) =>
    set((s) => ({ drafts: { ...s.drafts, [conversationId]: { status: 'ready', text } } })),
  clearDraft: (conversationId) =>
    set((s) => {
      if (!(conversationId in s.drafts)) return s
      const drafts = { ...s.drafts }
      delete drafts[conversationId]
      return { drafts }
    }),
}))
